import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

import store from '../store/index';
//import axios from 'axios';

Vue.use(VueRouter)

const routes = [
  {
    path: '/', 
    component: HomeView,
    name: 'home',
  },
  {
    path: '/?view=termofuse',
    name: 'termofuse',
    component: () => import(/* webpackChunkName: "about" */ '../views/TermOfUse.vue'),

  },
  {
    path: '/?view=accessibility',
    name: 'accessibility',
    component: () => import(/* webpackChunkName: "about" */ '../views/Accessibility.vue'),
  },
  {
    path: '/?view=login',
    name: 'login', 
    component: () => import(/* webpackChunkName: "about" */ '../views/LogInCard.vue'),
  },
  {
    path: '/?view=approve',
    name: 'approve', 
    component: () => import(/* webpackChunkName: "about" */ '../views/ApproveUserToken.vue'),
  },
  {
    path: '/?view=reset',
    name: 'reset', 
    component: () => import(/* webpackChunkName: "about" */ '../views/ResetPasswordCard.vue'),
  },
  {
    path: '/?view=register',
    name: 'register',
    component: () => import(/* webpackChunkName: "about" */ '../views/RegisterCard.vue'),

  },
  {
    path: '/?view=member',
    name: 'member',
    component: () => import(/* webpackChunkName: "about" */ '../views/MemberView.vue'),
  },
  {
    path: '/?view=notfound',
    name: 'notfound',
    component: () => import(/* webpackChunkName: "about" */ '../views/NotFound.vue'),

  },
  {
    path: '/?view=neighborhood&id=:neighborhoodId&page=deals',
    
    name: 'neighborhood',
    
    
    component: () => import(/* webpackChunkName: "about" */ '../views/NeighborhoodBuyView.vue'),
  },
  {
    path: '/?view=neighborhood_rent&id=:neighborhoodId&page=rent',
    
    name: 'neighborhood_rent',
    component: () => import(/* webpackChunkName: "about" */ '../views/NeighborhoodRentView.vue'),
  },
  {
    path: '/?view=street&id=:streetId&page=deals',
    
    name: 'street',
    
    
    component: () => import(/* webpackChunkName: "about" */ '../views/StreetsBuyView.vue'),
  },
  {
    path: '/?view=settlement&id=:setlCode&page=deals',//'/settlement/:setlCode/buy/deals',
    
    name: 'settlement',
    
    
    component: () => import(/* webpackChunkName: "about" */ '../views/SettlementBuyView.vue'),
  },
  {
    path: '/?view=settlement_rent&id=:setlCode&page=rent',//'/settlement/:setlCode/rent/pricing',
    
    name: 'settlement_rent',
    component: () => import(/* webpackChunkName: "about" */ '../views/SettlementRentView.vue'),
  },
  {
    path: '/?view=address&id=:addressId&page=deals', //'/address/:addressId/buy/deals',
    
    name: 'address',
    
    
    component: () => import(/* webpackChunkName: "about" */ '../views/AddressBuyView.vue'),
  },
  {
    path: '/?view=kparcel_all&id=:kParcel&page=deals', //'/kparcel_all/:kParcel/buy/deals',
    
    name: 'kparcel_all',
    
    
    component: () => import(/* webpackChunkName: "about" */ '../views/KparcelBuyView.vue'),
  },
  {
    path: '/?view=settlement_info&id=:setlCode&page=info',//'/settlement/:setlCode/buy/info',
    
    name: 'ma_basviva',
    
    
    component: () => import(/* webpackChunkName: "about" */ '../views/SettlementMaBasviva.vue'),
  },
  {
    path: '/?view=neighborhood_info&id=:neighborhoodId&page=info',
    
    name: 'ma_basviva_neighborhood',
    
    
    component: () => import(/* webpackChunkName: "about" */ '../views/NeighborhoodMaBasviva.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {

  if (to.query.page) {
    store.state.isMain = false;
    store.state.isPage = true;
  }
  else{
    store.state.isMain = true;
    store.state.isPage = false;
  }
   // do somthing with vue store.state value in my app...
   next();
 })


// router.afterEach((to, from) => {
//   // Your function to execute on route change
//   console.log('Route is changed from', from.fullPath, 'to', to.fullPath);
//   setTimeout(() => {
//     //go to top
//     window.scrollTo(0, 0);
//   }, 1000);
// })



export default router
